import React, { Component } from 'react';
import { Modal, Button } from 'antd';

if (!window.rmes) window.rmes = {}

window.rmes.confirm = function(title, content, onOk, onCancel) {
  Modal.confirm({
    title, content, onOk, onCancel
  })
}